/**
 * metaTestMode.js — flag a Meta SDK-bidding win whose ad request breaks Meta's test-mode rule.
 * Twin: proxy-server/lifecycle/metaTestMode.js (pinned by metaTestModeParity.test.js).
 *
 * Meta serves a test ad only when test mode is on in BOTH the bid (GAM adtest=on →
 * settings.test_request) and the SDK's own ad request (TEST_MODE=1 on
 * ep1|ep2.facebook.com/network_ads_common/, set by FBAdSettings addTestDevice on iOS or
 * AdSettings.setTestMode on Android). A mismatch gets 1001 no fill. Seen on every Meta win
 * in the iOS HARs of 18-20 Oct 2026; build 5.48.0 added TEST_MODE=1 and Meta filled 6 of 6.
 *
 * Joined exactly: GAM response buyer_sdk_ad bid_id (validData.expanded.sdkBidId) ===
 * the Meta request's BID_ID (validData.metaAdRequest.bidId). No Meta request seen (USB
 * capture, or *.facebook.com SSL-excluded) → no finding. Pure. Never throws.
 */

export function metaAdRequestFor(gamRow, sdkRows) {
  const bidId = gamRow && gamRow.validData && gamRow.validData.expanded && gamRow.validData.expanded.sdkBidId;
  if (!bidId) return null;
  for (const r of sdkRows || []) {
    const m = r && r.validData && r.validData.metaAdRequest;
    if (m && m.bidId && String(m.bidId) === String(bidId)) {
      return { ...m, rowKey: r._k != null ? r._k : (r.id != null ? r.id : null) };
    }
  }
  return null;
}

export function isTestAuction(gamRow) {
  const ex = (gamRow && gamRow.validData && gamRow.validData.expanded) || {};
  return ex.testRequest === true || /[?&]adtest=on(?:&|$)/.test(String((gamRow && gamRow.url) || ''));
}

/** Slot issue for a test auction whose Meta ad request is not in test mode, or null. */
export function metaTestModeIssue(gamRow, sdkRows) {
  try {
    if (!isTestAuction(gamRow)) return null;
    const adReq = metaAdRequestFor(gamRow, sdkRows);
    if (!adReq || adReq.testMode) return null;
    return {
      level: 'warn',
      msg: `Meta won a test auction (adtest=on), but Meta's SDK asked for the ad without TEST_MODE=1${adReq.code != null ? ` and got code ${adReq.code}` : ''}. Meta needs test mode on both sides, or it answers 1001 no fill: put the SDK in test mode in the QA build (FBAdSettings addTestDevice on iOS, AdSettings.setTestMode on Android)`,
      phase: 'winner',
      code: 'meta_test_mode_mismatch',
      rowKey: adReq.rowKey,
    };
  } catch { return null; }
}
